import axios from 'axios';
import { DEFAULT_PAYMENT_TERMS } from '../constants/defaultPaymentTerms';

/**
 * @returns {Promise<string[]>}
 */
export async function fetchPaymentTermsOptions() {
  try {
    const res = await axios.get('/api/settings/payment-terms');
    const terms = res?.data?.data?.terms;
    if (Array.isArray(terms) && terms.length > 0) return terms;
  } catch (err) {
    console.error('fetchPaymentTermsOptions:', err);
  }
  return [...DEFAULT_PAYMENT_TERMS];
}

/**
 * @param {string[]} terms
 */
export async function savePaymentTermsOptions(terms) {
  const res = await axios.put('/api/settings/payment-terms', { terms });
  const saved = res?.data?.data?.terms;
  if (Array.isArray(saved) && saved.length > 0) return saved;
  return terms;
}
